import React from "react";
import { actions } from '../../exports';
import "./plugin.css";
import classNames from 'classnames';

class ThetaSlider extends React.Component {

  handleClick(name,item) {
  	
    let originOptions = this.props.options;
    let _options = undefined;
    if (originOptions.captureMode === 'image') {
      _options = originOptions.image;
    } else {
      _options = originOptions.video;
    }
  	let setOptions = { 
  	  name: 'camera.setOptions',
  	  parameters: {}
  	};
  	
    if (name === 'action') {
          _options.exposureProgram = item.val;
          _options.exposureProgramTitle = item.title;
          _options.exposureProgramIcon = item.icon;
          originOptions.exposureProgramOpen = false;
          
        switch(_options.exposureProgram) {
          case 2:
         	    setOptions.parameters.options = {
      	      exposureProgram: String(item.val)
      	    };
            break;
          case 3:
         	    setOptions.parameters.options = {
      	      exposureProgram: String(item.val),
      	      aperture: _options.aperture.aperture,
              exposureCompensation: _options.aperture.exposureCompensation,
              whiteBalance: _options.aperture.whiteBalance
      	    };
            break;
          case 4:
         	    setOptions.parameters.options = {
      	      exposureProgram: String(item.val),
              shutterSpeed: _options.shutter.shutterSpeed,
              exposureCompensation: _options.shutter.exposureCompensation,
              whiteBalance: _options.shutter.whiteBalance
      	    };
            break;
          case 9:
         	    setOptions.parameters.options = {
      	      exposureProgram: String(item.val),
              iso: _options.iso.iso,
              exposureCompensation: _options.iso.exposureCompensation,
              whiteBalance: _options.iso.whiteBalance
      	    };
            break;
          case 1:
         	    setOptions.parameters.options = {
      	      exposureProgram: String(item.val),
              iso: _options.manual.iso,
              shutterSpeed: _options.manual.shutterSpeed,
              whiteBalance: _options.manual.whiteBalance
      	    };
            break;
          default:
            return;
        }
      }
      this.props.startTimer();
      if (originOptions.captureMode === 'image') {
        originOptions.image = _options;
      } else {
        originOptions.video = _options;
      }
  
      originOptions.command = setOptions;
      this.setState({
        options: originOptions
      });
      this.props.updateState({
        options: originOptions
      });
    }

  render() {
    const { select,devicename } = this.props;
    let version = devicename.substr(5,2);
    if (select === 'actions') {
        return (
    	  <ul id="action_sheet__btn_list">
            { actions.map((item,i) => (
              item.version.includes(version) &&
          		<li>
          		<input name='action' type='radio' className={classNames('btn--data__value')} value={`${item.val}`} id={`action${i}`} onClick={() => {this.handleClick('action',item)}}/>
          		<label for={`action${i}`} class="action">{`${item.title}`}</label>
          		</li>
            ))}
        </ul>
        );
    } else {
        return (
          <div/>
        );
    }
  }
}

export default ThetaSlider;



// WEBPACK FOOTER //
// ./src/components/shooting/ThetaSlider.js